const ROW_FIELDS = `
                id
                rowTime
                kind
                eventId
                legId
                isActive
                planData
                opsData
                actualData
                priceData
                metaData
                fuelFlagLevel`;
export const FUEL_ROW_PLAN_RANGE_QUERY = `
    query FuelStoredPlanRows($aircraftId: ID!, $from: String!, $to: String!, $nextToken: String) {
        listAircraftFuelRowsByAircraftId(
            aircraftId: $aircraftId
            rowTime: { between: [$from, $to] }
            sortDirection: ASC
            limit: 150
            nextToken: $nextToken
        ) {
            items {${ROW_FIELDS}
            }
            nextToken
        }
    }
`;
export const FUEL_ROW_PLAN_GET_QUERY = `
    query FuelStoredPlanRow($id: ID!) {
        getAircraftFuelRow(id: $id) {${ROW_FIELDS}
        }
    }
`;
export const FUEL_STORED_READ_REQUIRED_FIELDS = [
    {
        name: 'planRowsRange',
        document: FUEL_ROW_PLAN_RANGE_QUERY,
        fields: ['id', 'rowTime', 'kind', 'eventId', 'legId', 'isActive', 'planData', 'opsData', 'actualData', 'priceData', 'metaData', 'fuelFlagLevel', 'nextToken'],
    },
    {
        name: 'planRowGet',
        document: FUEL_ROW_PLAN_GET_QUERY,
        fields: ['id', 'rowTime', 'kind', 'eventId', 'legId', 'isActive', 'planData', 'opsData', 'actualData', 'priceData', 'metaData', 'fuelFlagLevel'],
    },
];
//# sourceMappingURL=storedRowReads.js.map